import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { deleteATvProgram, getTvPrograms, resetState } from "../features/TvProgram/TvProgramSlice";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
  },
  {
    title: "Time",
    dataIndex: "time",
  },
  
  {
    title: "Logo",
    dataIndex: "logo",
    render: logo => <img src={logo} alt="TvProgram Logo" style={{ width: 50, height: 50 }} />,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const TvProgramlist = () => {
  const [open, setOpen] = useState(false);
  const [TvProgramId, setTvProgramId] = useState("");
  const showModal = (e) => {
    setOpen(true);
    setTvProgramId(e);
  };

  const hideModal = () => {
    setOpen(false);
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(resetState());
    dispatch(getTvPrograms());
  }, []);
  const getTvProgramState = useSelector((state) => state.radioprogram.TvPrograms);
  console.log(getTvProgramState);
  const data1 = [];
  console.log(getTvProgramState.length);
  for (let i = 0; i < getTvProgramState.length; i++) {
    data1.push({
      key: i + 1,
      name: getTvProgramState[i].name,
      time: getTvProgramState[i].time,
      logo: getTvProgramState[i].image,

      action: (
        <>
          <Link
            to={`/admin/Add-TvProgram/${getTvProgramState[i]._id}`}
            className=" fs-3 text-danger"
          >
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(getTvProgramState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }
  const deleteNews = (e) => {
    dispatch(deleteATvProgram(e));

    setOpen(false);
    setTimeout(() => {
      dispatch(getTvPrograms());
    }, 100);
  };
  return (
    <div>
      <h3 className="mb-4 title">TvProgram List</h3>
      <div>
        <Table columns={columns} dataSource={data1} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => {
          deleteNews(TvProgramId);
        }}
        title="Are you sure you want to delete this TvProgram?"
      />
    </div>
  );
};

export default TvProgramlist;
